import React, { useEffect, useMemo, useRef, useState, useCallback } from 'react';
import { useParticipantIds, useDailyEvent, useDaily } from '@daily-co/daily-react';
import { useRecoilState, useSetRecoilState, useRecoilValue } from 'recoil';
import { isAuthAtom, isAuthLoadedAtom, recordLocalAtom } from '../../State';
import { onAuthStateChanged, getAuth } from 'firebase/auth';
import { useParams, useNavigate, useSearchParams } from 'react-router-dom';
import AddAccess from '../Util/AddAccess';

export default function FuncLeaveRoom({ isLeave }) {
  const [authState, setAuthState] = useRecoilState(isAuthAtom);
  const [isAuthLoadedState, setIsAuthLoadedState] = useRecoilState(isAuthLoadedAtom);
  const [recordLocalState, setRecordLocalState] = useRecoilState(recordLocalAtom);
  const navigate = useNavigate(); //リダイレクト用

  //ログイン情報取得
  useEffect(() => {
    if (isLeave) {
      //録画していたらストップ
      setRecordLocalState(false);

      //ログインしている場合
      if (authState) {
        navigate('/app', { state: { comeFromExit: true } });
      }
      //ログインしていない場合
      else {
        //フィードバックページへ
        navigate('/feedback', { state: { comeFromExit: true } });
      }

      //アクセス
      AddAccess('pave-view', 'leftRoom');
    }
  }, [isLeave]);
  //レンダービュー
  return false;
}
